module.exports = __webpack_public_path__ + "img/RKD-O-front.5e082d53.jpg";